import React, { Component } from 'react';
import { Link } from 'react-router';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import FontIcon from 'material-ui/FontIcon';
import { grey500 } from 'material-ui/styles/colors';
import { connect } from 'react-redux';
import { menuStatus } from '../actions/fetch_topusers';
import { bindActionCreators } from 'redux';
import { userLogout } from '../utility/logout';

const iconStyles = {
  marginRight: 24,
  display:'inline'
};


class MenuCustom extends Component {

  handleClose = () =>{
    this.props.menuStatus(false);
  }

  logout = () =>{
    userLogout()
  }

  render(){
    const { menuSetting } = this.props; 
    const menuColor = menuSetting === true ? 'grey': '#fff'; 
    return (
        <div className={`aside_menu ${this.props.bgSetting}`}>
          <Menu menuItemStyle={{width:250,textAlign:'left'}}>
            <MenuItem className={`menuhover ${this.props.bgSetting}`} primaryText="分析設定"  style={{color:'#fff'}} leftIcon={<span className="sprite1 sprite-icon01-c"></span>}  containerElement={<Link to="/" />} />
            <Divider style={{width:'100%'}} />
            <MenuItem primaryText="總覽" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon02-active"></span>}  containerElement={<Link to="/overview" />} />
            <MenuItem primaryText="粉專熱文" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon03-active"></span>}  containerElement={<Link to="/posttype" />}/>
            <MenuItem primaryText="發文影響力" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon04-active"></span>} containerElement={<Link to="/post_interaction" />}/>
            <MenuItem primaryText="重疊粉絲" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon05-active"></span>}  containerElement={<Link to="/fananalysis" />}/>
            <MenuItem primaryText="粉絲排行" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon06-active"></span>}  containerElement={<Link to="/fanpost" />}/>
            <MenuItem primaryText="小編互動" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite1 sprite-icon07-active"></span>}  containerElement={<Link to="/fangroup" />}/>
            <MenuItem primaryText="鐵粉分析" onTouchTap={this.handleClose} style={{color:menuColor}} disabled={menuSetting} leftIcon={<span className="sprite2 sprite-icon010-active"></span>}  containerElement={<Link to="/loyalty" />}/>
            <Divider style={{width:'100%'}} />
            {/*<MenuItem className={`menuhover ${this.props.bgSetting}`} primaryText="管理" style={{color:'#fff'}} leftIcon={<span className="sprite1 sprite-icon08-active"></span>}  containerElement={<Link to="/user_setting" />}/>*/}
            <MenuItem onTouchTap={this.logout} className={`menuhover ${this.props.bgSetting}`} primaryText="登出" style={{color:'#fff'}} leftIcon={<span className="sprite1 sprite-icon09-active"></span>} />
          </Menu>
      </div>
      )
  }
}

function mapStateToProps({menuSetting, bgSetting}) {
  return { menuSetting, bgSetting };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ menuStatus }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuCustom);



// WEBPACK FOOTER //
// ./src/components/menu_custom.js